import type { IconData } from '@stacksjs/iconify-core'

export const mv4x3: IconData = {
  "body": "<path fill=\"#d21034\" d=\"M0 0h640v480H0z\"/><path fill=\"#007e3a\" d=\"M120 120h400v240H120z\"/><circle cx=\"350\" cy=\"240\" r=\"80\" fill=\"#fff\"/><circle cx=\"380\" cy=\"240\" r=\"80\" fill=\"#007e3a\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default mv4x3
